<template>
  <section class="travel-group-list">
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedArea"
              :loading="loadingAreas"
              :placeholder="$t('message.please_select') + $t('attributes.area')"
              @input="onSelectArea"
            >
              <option value="">
                {{ $t('attributes.all_area') }}
              </option>
              <option
                v-for="option in areaList"
                :value="option"
                :key="option.code"
              >
                {{ !option.status ? '[下架]' : '' }}
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.date_range') }}
              </span>
            </p>
            <b-datepicker
              :placeholder="
                $t('message.please_select') + $t('attributes.date_range')
              "
              v-model="selectedDates"
              range
              @input="onSelectedDates"
            >
              <button class="button is-danger" @click="onClearDates">
                <b-icon icon="close"></b-icon>
                <span>Clear</span>
              </button>
            </b-datepicker>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.cowell_group_code') }}
              </span>
            </p>
            <b-input
              v-model="searchCode"
              :placeholder="
                $t('attributes.search') + $t('attributes.cowell_group_code')
              "
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.group_name') }}
              </span>
            </p>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
          <b-field>
            <b-button :loading="isLoading" type="is-link" @click="onFilter">
              {{ $t('attributes.search') }}
            </b-button>
          </b-field>
          <b-field class="ml-auto">
            <b-button
              :loading="isLoading"
              type="is-link is-light"
              @click="onUpload"
            >
              {{ $t('attributes.import') }}
            </b-button>
          </b-field>
        </b-field>
      </div>
      <b-modal
        v-model="isUploadModelActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        :can-cancel="false"
        aria-role="dialog"
        aria-label="Example Modal"
        close-button-aria-label="Close"
        aria-modal
      >
        <template #default="props">
          <form action="">
            <div class="modal-card" style="width: 480px;">
              <section class="modal-card-body">
                <div class="block">
                  <b-field>
                    <h2 style="font-size: 20px; margin-bottom: 40px;">
                      請上傳Excel檔案
                      <br />包含以下欄位：「出發日」、「團體代碼」、「團名」
                    </h2>
                  </b-field>
                  <b-field>
                    <b-upload
                      v-model="file"
                      accept=".xls,.xlsx"
                      multiple
                      drag-drop
                      required
                      style="display: block;"
                      @input="onUploadFile"
                      :disabled="isImporting"
                    >
                      <section class="section">
                        <div class="content has-text-centered">
                          <p>
                            <b-icon icon="upload" size="is-large"></b-icon>
                          </p>
                          <p>{{ fileName }}</p>
                        </div>
                      </section>
                    </b-upload>
                  </b-field>
                  <b-field v-if="isImporting">
                    <b-progress
                      :value="importProgress"
                      show-value
                      type="is-primary"
                      size="is-medium"
                      format="percent"
                      style="width: 100%;"
                    >
                    </b-progress>
                  </b-field>
                </div>
              </section>
              <footer class="modal-card-foot">
                <b-button
                  label="取消"
                  @click="closeUploadModal"
                  :disabled="isImporting"
                />
                <b-button
                  label="匯入科威團體資料"
                  type="is-primary"
                  :loading="isImporting"
                  :disabled="!hasFile || isImporting"
                  @click="importCowellGroupList"
                />
              </footer>
            </div>
          </form>
        </template>
      </b-modal>
      <b-modal
        v-model="isEditorActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        :can-cancel="false"
        aria-role="dialog"
        aria-label="Example Modal"
        close-button-aria-label="Close"
        aria-modal
      >
        <template #default="props">
          <form action="">
            <div class="modal-card" style="width: 800px; height: 450px;">
              <header class="modal-card-head">
                <p class="modal-card-title is-centered">旅行團維護</p>
              </header>
              <section class="modal-card-body">
                <form-group
                  horizontal
                  name="area"
                  :label="$t('attributes.area')"
                >
                  <b-input
                    v-model="form.area_name"
                    name="area"
                    expanded
                    :readonly="true"
                    disabled
                  >
                  </b-input>
                </form-group>
                <form-group
                  horizontal
                  name="code"
                  :label="$t('attributes.cowell_group_code')"
                >
                  <b-input
                    v-model="form.code"
                    name="code"
                    expanded
                    :readonly="true"
                    disabled
                  >
                  </b-input>
                </form-group>
                <form-group
                  horizontal
                  name="status"
                  :label="$t('attributes.status')"
                >
                  <b-input
                    v-model="form.status"
                    name="status"
                    expanded
                    :readonly="true"
                    disabled
                  >
                  </b-input>
                </form-group>
                <form-group
                  horizontal
                  name="departure_date"
                  :label="$t('attributes.departure_date')"
                >
                  <b-datepicker
                    :placeholder="
                      $t('message.please_select') +
                        $t('attributes.departure_date')
                    "
                    v-model="form.departure_date"
                  >
                  </b-datepicker>
                </form-group>
                <form-group
                  horizontal
                  name="name"
                  :label="$t('attributes.group_name')"
                >
                  <b-input v-model="form.name" name="name" expanded></b-input>
                </form-group>
                <form-group
                  horizontal
                  name="days"
                  :label="$t('attributes.days')"
                >
                  <b-input
                    type="number"
                    v-model="form.days"
                    name="days"
                    expanded
                  >
                  </b-input>
                </form-group>
              </section>
              <footer class="modal-card-foot">
                <b-button
                  :loading="isUpdating"
                  class="is-fullwidth"
                  @click="closeEditorModal"
                >
                  {{ $t('attributes.close') }}
                </b-button>
                <b-button
                  :loading="isUpdating"
                  type="is-primary"
                  class="is-fullwidth"
                  @click="update"
                >
                  {{ $t('attributes.update') }}
                </b-button>
              </footer>
            </div>
          </form>
        </template>
      </b-modal>
    </nav>
    <h3 style="text-align: center; font-size: 24px; margin: 40px 0 0 0;">
      總共：{{ total }} 筆資料
    </h3>
    <b-table
      :data="groups"
      :loading="isLoading"
      :mobile-cards="false"
      hoverable
      narrowed
      bordered
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
      :total="total"
      :current-page="parseInt(page)"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
    >
      <b-table-column
        field="departure_date"
        :label="$t('attributes.departure_date')"
        sortable
        centered
        width="160"
        v-slot="props"
      >
        {{ formatDate(props.row.departure_date) }}
      </b-table-column>
      <b-table-column
        field="area"
        :label="$t('attributes.area')"
        width="160"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.area_name }}
      </b-table-column>
      <b-table-column
        field="code"
        :label="$t('attributes.cowell_group_code')"
        width="160"
        sortable
        v-slot="props"
      >
        {{ props.row.code }}
      </b-table-column>
      <b-table-column
        field="name"
        :label="$t('attributes.group_name')"
        sortable
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>
      <b-table-column
        field="days"
        :label="$t('attributes.days')"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.days }}
      </b-table-column>
      <b-table-column
        field="status"
        :label="$t('attributes.status')"
        width="160"
        sortable
        centered
        v-slot="props"
      >
        {{ props.row.status }}
      </b-table-column>
      <b-table-column
        field="status"
        :label="$t('attributes.function')"
        width="200"
        sortable
        centered
        v-slot="props"
      >
        <b-button
          :loading="isLoading"
          type="is-primary"
          @click="showEditor(props.row)"
        >
          {{ $t('attributes.edit') }}
        </b-button>
        <b-button
          :label="$t('attributes.delete')"
          style="margin-left: 20px;"
          type="is-danger"
          @click="onDelete(props.row)"
          :disabled="!isAdmin"
        />
      </b-table-column>
    </b-table>
    <b-loading :active="isLoading" :is-full-page="true" :can-cancel="false" />
  </section>
</template>
<script>
import { AREA_API, TRAVEL_GROUP_BY_COWELL } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'CowellGroupList',
  data() {
    const { query } = this.$route
    let startDate = null
    let endDate = null
    let selectedDates = []
    if (query.start && query.end) {
      startDate = this.$dayjs.unix(query.start).toDate()
      endDate = this.$dayjs.unix(query.end).toDate()
      selectedDates = [startDate, endDate]
    }
    return {
      isLoading: false,
      status: query.status || '',
      searchCode: query.code || '',
      searchName: query.search || '',
      sortField: query.sort || 'code',
      sortOrder: query.order || 'asc',
      defaultSortOrder: 'asc',
      page: query.page || 1,
      perPage: query.page_size || 20,
      showExpired: query.exp || false,

      total: 0,
      groups: [],

      selectedDates,
      startDate,
      endDate,

      isUploadModelActive: false,
      hasFile: false,
      file: [],
      fileName: '上傳科威「團體銷售動態表」',
      isImporting: false,
      importProgress: 0,

      isEditorActive: false,
      form: this.extractFormValues(),
      isUpdating: false,

      admins: ['462', '026', '567', '578'],
      isAdmin: false,

      areaList: [],
      loadingAreas: false,
      selectedArea: null
    }
  },
  mounted() {
    this.checkAdmin()
    this.loadAreas()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.getQuery(to.query)
      this.onFilter()
    }

    next()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areaList = areas.sort(a => a.sort)
        this.selectedArea = null

        await this.onFilter()
      } catch (e) {
        this.areaList = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async onSelectArea(item) {
      this.selectedArea = item

      await this.onFilter()
    },
    async onFilter() {
      try {
        const api = `${TRAVEL_GROUP_BY_COWELL}`
        this.isLoading = true
        const params = {
          status: this.status,
          start_date: this.formatDate(this.startDate),
          end_date: this.formatDate(this.endDate),
          show_expired: this.showExpired,
          area_code: this.selectedArea ? this.selectedArea.code : null,
          code: this.searchCode,
          name: this.searchName,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }
        const response = await this.axios.get(api, { params })
        const data = response.data.data
        this.groups = data.items
        this.total = data.item_count
      } catch (e) {
        this.groups = []
        this.total = 0
        notifyService.error('查詢出現錯誤', e)
      } finally {
        this.isLoading = false
      }
    },
    checkAdmin() {
      const empCode = this.$store.getters.empCode
      if (this.admins.includes(empCode)) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        type: 'is-danger',
        cancelText: this.$t('attributes.cancel'),
        confirmText: this.$t('attributes.delete'),
        onConfirm: () => {
          this.deleteGroup(item)
        }
      })
    },
    async deleteGroup(item) {
      try {
        const api = `${TRAVEL_GROUP_BY_COWELL}/${item.code}/delete`

        this.isLoading = true
        await this.axios.put(api)

        notifyService.success(this.$t('attributes.delete_succeed'))

        await this.onFilter()
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.isLoading = false
      }
    },
    showEditor(item) {
      this.form = this.extractFormValues(item)
      this.isEditorActive = true
    },
    extractFormValues(item) {
      if (!item) {
        return {
          code: '',
          departure_date: null,
          name: '',
          status: '',
          area_name: '',
          days: ''
        }
      }
      return {
        code: item.code,
        departure_date: item.departure_date
          ? this.$dayjs(item.departure_date).toDate()
          : null,
        name: item.name,
        status: item.status,
        area_name: item.area_name,
        days: item.days
      }
    },
    async update() {
      if (this.form.code === null) {
        this.$buefy.dialog.alert({
          title: '警告',
          message: '請指定一個旅行團做更新。',
          confirmText: '確定'
        })
      }
      try {
        const api = `${TRAVEL_GROUP_BY_COWELL}/${this.form.code}`

        this.isUpdating = true
        await this.axios.put(api, this.form)
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.onFilter()
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.isUpdating = false
        this.isEditorActive = false
      }
    },
    onUpload() {
      this.isUploadModelActive = true
    },
    onUploadFile() {
      this.fileName = this.file[0].name
      this.hasFile = true
    },
    closeUploadModal() {
      this.file = []
      this.fileName = '上傳科威「團體銷售動態表」'
      this.hasFile = false
      this.isUploadModelActive = false
    },
    closeEditorModal() {
      this.form = []
      this.isEditorActive = false
    },
    async importCowellGroupList() {
      if (this.file === null || this.file.length === 0) {
        return
      }
      try {
        const api = `${TRAVEL_GROUP_BY_COWELL}/import-cowell-groups`
        const config = {
          headers: { Accept: 'application/json' },
          onUploadProgress: event => {
            if (event && event.total) {
              this.importProgress = Math.round(
                (event.loaded * 100) / event.total
              )
            }
          }
        }
        const formData = new FormData()
        formData.append('file', this.file[0])
        this.isImporting = true
        this.importProgress = 0

        const response = await this.axios.post(api, formData, config)
        const result =
          response && response.data ? response.data.data.total : null
        notifyService.success('匯入完成，總共匯入' + result + '筆資料')
        this.isUploadModelActive = false
        await this.onFilter()
      } catch (e) {
        notifyService.error('匯入失敗', e)
      } finally {
        this.file = []
        this.fileName = '上傳科威「團體銷售動態表」'
        this.hasFile = false
        this.isImporting = false
        this.importProgress = 0
      }
    },
    onSelectedDates(dates) {
      this.selectedDates = dates
      this.startDate = this.selectedDates[0]
      this.endDate = this.selectedDates[1]
    },
    onClearDates() {
      this.page = 1
      this.selectedDates = null
      this.startDate = null
      this.endDate = null
    },
    getQuery(query) {
      this.status = query.status || ''
      this.searchCode = query.code || ''
      this.searchName = query.search || ''
      this.sortField = query.sort || 'code'
      this.sortOrder = query.order || 'asc'
      this.page = query.page || 1
      this.perPage = query.page_size || 10
      this.showExpired = query.exp || false

      if (query.start && query.end) {
        this.startDate = this.$dayjs.unix(query.start).toDate()
        this.endDate = this.$dayjs.unix(query.end).toDate()
      } else {
        this.startDate = null
        this.endDate = null
      }
    },
    updateQuery() {
      const query = {
        status: this.filterStatus,
        exp: this.showExpired,
        code: this.searchCode,
        search: this.searchName,
        sort: this.sortField,
        order: this.sortOrder,
        page_size: this.perPage,
        page: this.page,
        start: this.startDate && this.$dayjs(this.startDate).unix(),
        end: this.endDate && this.$dayjs(this.endDate).unix()
      }
      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },
    onPageChange(page) {
      this.page = page
      this.updateQuery()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.updateQuery()
    }
  }
}
</script>
